module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-2.2b401911.svg";